import { ApiBase } from './api-base';

export interface ICreatorPoll {
  pollTitle: string;
  pollOptions: string;
  pollLength: string;
  creatorId: string;
  isDrafted: string;
  pollStatus: string;
}

export class CreatorPollsApi extends ApiBase {
  model = 'creatorPolls';

  createPoll(body: any) {
    return this.http.post<any>(`${this.modelBase}`, body);
  }

  editPollbyId(id: string, body: any) {
    return this.http.patch<any>(`${this.modelBase}/${id}`, body);
  }

  getPollbyId(id: string) {
    return this.http.get<any>(`${this.modelBase}/${id}`);
  }

  getCreatorPolls(creatorId: string, isDrafted: boolean, pollStatus?: string) {
    return this.http.get<any>(`${this.modelBase}/creator/${creatorId}`, {
      params: {
        pollStatus: pollStatus,
        isDrafted: isDrafted.toString()
      }
    });
  }

  getCreatorDraftedPolls(creatorId: string, isDrafted: boolean) {
    return this.http.get<any>(`${this.modelBase}/creator/${creatorId}`, {
      params: {
        isDrafted: isDrafted.toString()
      }
    });
  }

  deletePoll(id: string) {
    return this.http.delete<any>(`${this.modelBase}/${id}`);
  }
}
